
import {
  StorageLocationDto,
  CreateStorageLocationDto,
  UpdateStorageLocationDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type StorageLocationsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
}

class StorageLocationService extends BaseCrudService<
  StorageLocationDto,
  CreateStorageLocationDto,
  UpdateStorageLocationDto,
  StorageLocationsFilters
> {
  constructor() {
    super('storage-location', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const storageLocationService = new StorageLocationService()
